import { useEffect } from "react";
import { useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";
import { usePane } from "../../main/panes/paneLayout/usePane";
import { useRefetchWhenPaneSaves } from "../../main/panes/usePanes";
import { useTaskPaneNavigation, useTaskQuery } from "./TaskPaneContent.hooks";
import { getTaskMasterDataUrl } from "./masterDataSection/MasterDataSection.hooks";
import { TaskPaneProps } from "./TaskPane";

export function useTaskPane(props: TaskPaneProps) {
    const { close } = usePane();
    const queryClient = useDotLegalQueryClient();
    const { activeTaskId, navigateToTask } = useTaskPaneNavigation(props.taskId);

    // Saving the activity next door can regenerate its tasks and delete this one, which would otherwise
    // throw the 404 into the nearest error boundary. This pane watches for that itself and goes quietly.
    const { error: taskError, refetch: refetchTask } = useTaskQuery(activeTaskId, { throwOnError: false });
    const taskIsGone = Boolean(taskError);

    // Master data is a query of its own, so refreshing the task alone would show the activity's new name
    // beside its old deadline.
    useRefetchWhenPaneSaves(() => {
        refetchTask();
        queryClient.refetchQueries(getTaskMasterDataUrl(activeTaskId));
    });

    useEffect(() => {
        if (taskIsGone) {
            close();
        }
    }, [taskIsGone, close]);

    return { activeTaskId, navigateToTask, taskIsGone };
}
